import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import CrmSchedulerRulesAPI from '../../api/crmSchedulerRules';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getRules(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_CRM_SCHEDULER_RULE_UI_FLAG, { isFetching: true });
    try {
      const response = await CrmSchedulerRulesAPI.get();
      commit(types.SET_CRM_SCHEDULER_RULES, response.data.payload);
    } finally {
      commit(types.SET_CRM_SCHEDULER_RULE_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, rule) => {
    commit(types.SET_CRM_SCHEDULER_RULE_UI_FLAG, { isCreating: true });
    try {
      const response = await CrmSchedulerRulesAPI.create(rule);
      commit(types.ADD_CRM_SCHEDULER_RULE, response.data.payload);
    } finally {
      commit(types.SET_CRM_SCHEDULER_RULE_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...rule }) => {
    commit(types.SET_CRM_SCHEDULER_RULE_UI_FLAG, { isUpdating: true });
    try {
      const response = await CrmSchedulerRulesAPI.update(id, rule);
      commit(types.EDIT_CRM_SCHEDULER_RULE, response.data.payload);
    } finally {
      commit(types.SET_CRM_SCHEDULER_RULE_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_CRM_SCHEDULER_RULE_UI_FLAG, { isDeleting: true });
    try {
      await CrmSchedulerRulesAPI.delete(id);
      commit(types.DELETE_CRM_SCHEDULER_RULE, id);
    } finally {
      commit(types.SET_CRM_SCHEDULER_RULE_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_CRM_SCHEDULER_RULE_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.ADD_CRM_SCHEDULER_RULE]: MutationHelpers.create,
  [types.SET_CRM_SCHEDULER_RULES]: MutationHelpers.set,
  [types.EDIT_CRM_SCHEDULER_RULE]: MutationHelpers.update,
  [types.DELETE_CRM_SCHEDULER_RULE]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
